import { render, staticRenderFns } from "./DocumentUploadDlg.vue?vue&type=template&id=5f41dd40&scoped=true"
import script from "./DocumentUploadDlg.vue?vue&type=script&lang=js"
export * from "./DocumentUploadDlg.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploadDlg.vue?vue&type=style&index=0&id=5f41dd40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41dd40",
  null
  
)

export default component.exports